// SPDX-FileCopyrightText: 2025 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import { useQuery } from '@tanstack/react-query';
import { get } from '@tls/auth';
import { GenericResponse } from 'model/reponse/GenericResponse';

export type KpiData = {
  isSuccess: boolean;
  lastFetch: string;
  nextFetch?: string;
  lastError?: string;
};

export type KpiResponse = {
  [key: string]: KpiData;
};

export default function useContractKpiApi() {
  const { data, isLoading } = useQuery<GenericResponse<KpiResponse>>({
    queryKey: ['dataAgreement'],
    queryFn: async () => await get('contracts/kpi', false, true),
  });

  return { contractKpi: data?.data, isLoading };
}
